import { render, staticRenderFns } from "./VirtualExp.vue?vue&type=template&id=72a46f98&scoped=true&"
import script from "./VirtualExp.vue?vue&type=script&lang=js&"
export * from "./VirtualExp.vue?vue&type=script&lang=js&"
import style0 from "./VirtualExp.vue?vue&type=style&index=0&id=72a46f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a46f98",
  null
  
)

export default component.exports